export enum KeyContact {
  Finance = "Finance",
  Compliance = "Compliance",
  ProductUpdate = "Product Updates"
}
